/**
 * The card grid of a section landing (2026-09-28, Teo: the old landings re-listed the
 * sidebar as sections + pills + a rail; "not how docs are usually organised"). One card
 * per page: eyebrow (the folders above a KingCAD page), title, a muted second line (the
 * publisher half of a comma-split folder name), the layer count and the first layer names.
 * Reuses the Pregled card styles (`.docs-card`).
 */

import { esc } from '../docsHtml.js';
import type { LandingCard } from '../docsModel.js';

function renderCard(c: LandingCard): string {
  return `
      <a class="docs-card" href="${esc(c.href)}" data-docs-link>
        ${c.eyebrow ? `<span class="docs-card-eyebrow">${esc(c.eyebrow)}</span>` : ''}
        <span class="docs-card-title">${esc(c.title)}</span>
        ${c.sub ? `<span class="docs-card-sub">${esc(c.sub)}</span>` : ''}
        <span class="docs-card-meta">${esc(c.meta)}</span>
        ${c.teaser ? `<span class="docs-card-text">${esc(c.teaser)}</span>` : ''}
      </a>`;
}

export function renderCards(cards: readonly LandingCard[]): string {
  if (cards.length === 0) return '';
  return `<div class="docs-cards docs-cards--landing">${cards.map(renderCard).join('')}</div>`;
}
